import { useLingui } from '@lingui/react/macro';
import { CheckoutTypeParam } from 'src/api/endpoints/storeApi.types';
import { Feedback, SomethingWentWrong, Spinner } from 'src/components';
import { AppPage } from 'src/components/AppPage';
import { URLS } from 'src/utils/urls/urls';

import { SubscriptionSummaryCard } from '../components/SubscriptionSummaryCard';
import { useCheckoutConfirmation } from '../useCheckoutConfirmation';

export const WinbackOfferConfirmationPage = () => {
  const { t } = useLingui();
  const { isPending, isError, error, paymentConfirm, subscription } =
    useCheckoutConfirmation({
      checkoutType: CheckoutTypeParam.WINBACK_OFFER,
    });

  if (isPending) {
    return <Spinner />;
  }
  if (isError) {
    return <SomethingWentWrong error={error} />;
  }

  if (!paymentConfirm) {
    return (
      <SomethingWentWrong
        error={
          new Error(
            'Tried to render WinbackOfferConfirmationPage, but paymentConfirm does not exist'
          )
        }
      />
    );
  }

  if (!subscription) {
    return (
      <SomethingWentWrong
        error={
          new Error(
            'Tried to render WinbackOfferConfirmationPage, but subscription does not exist'
          )
        }
      />
    );
  }

  const nextBillingDate = new Date(subscription.createdAt ?? '');
  nextBillingDate.setMonth(nextBillingDate.getMonth() + 1);

  return (
    <AppPage.Container>
      <AppPage.Content className="max-w-ll pt-24 lm:pt-64">
        <SubscriptionSummaryCard
          subscription={subscription}
          paymentConfirm={paymentConfirm}
          to={URLS.STORE_METHODS_OFFER_DOWNLOAD_APPS}
        />

        <Feedback
          className="my-32"
          title={t`Did you find what you were looking for?`}
          feedbackTargetId="store-winback-offer-confirmation"
        />
      </AppPage.Content>
    </AppPage.Container>
  );
};
